export default __webpack_public_path__ + "static/media/barrel.6adceec5.glb";